import React from 'react';
import PropTypes from 'prop-types';
import { emit } from 'helpers/global-events';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import Button, { btnThemes } from 'components/button';
import Notification from 'components/notification';
import Row, { Col } from 'components/row';

const config = {
  important: {
    labelSet: 'Важные',
    labelUnset: 'Неважные'
  },
  locked: {
    labelSet: 'Закрыть',
    labelUnset: 'Открыть'
  },
  stick: {
    labelSet: 'Прикрепить',
    labelUnset: 'Открепить'
  },
};

@apiDecorator
export default class StatusTopic extends React.PureComponent {
  static propTypes = {
    topicItems: PropTypes.arrayOf(PropTypes.shape({})),
    statusType: PropTypes.string,
    onResetSelection: PropTypes.func
  };

  // Action for closing modal window
  static contextTypes = {
    close: PropTypes.func.isRequired
  };

  constructor(...args) {
    super(...args);
    this.statusTopics = this.statusTopics.bind(this);
  }

  /**
   * Change status for topics in DB.
   *
   * @param topics array with topics
   * @param statusType type of status (important, locked, stick)
   * @param status set/unset status
   */
  statusTopics(topics, statusType, status) {
    this.api.post('action/forum/actions-change-status-topics/change-status', {
      postData: {
        topics,
        statusType,
        status
      }
    })
      .then(() => this.afterStatusTopics(topics))
      .catch(error => reportError(error));
  }

  // Call after success save topics data.
  afterStatusTopics(topics) {
    Notification.success('Статус темы успешно изменен.');

    // Close modal window.
    if (this.context && this.context.close) this.context.close();

    this.props.onResetSelection(false, topics);

    // Update topics.
    emit('updateClubTopics');
  }

  render() {
    const { topicItems, statusType } = this.props;

    return (
      <Row>
        <Col allPr={20} allPb={20}>
          <Button
            onClick={() => this.statusTopics(topicItems, statusType, true)}
            label={config[statusType].labelSet}
            title={config[statusType].labelSet}
            theme={btnThemes.sky}
            big
          />
        </Col>
        <Col allPr={0} allPb={20} allFlex allJustifyCFlexEnd>
          <Button
            onClick={() => this.statusTopics(topicItems, statusType, false)}
            label={config[statusType].labelUnset}
            title={config[statusType].labelUnset}
            theme={btnThemes.light}
            big
          />
        </Col>
      </Row>
    );
  }
}
